module.exports = __webpack_public_path__ + "img/horizontal_7_7_3009.5b42c213.png";